import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnDestroy {

  @Output() modalClose: EventEmitter<void>;
  @Input() cssClass = '';
  @Input() headerClass = '';
  @Input() bodyClass = '';
  @Input() closable = true;
  @Input() appendToBody = false;

  startY = 0;
  currentTranslateY = 0;
  threshold = 150;
  animateBack = false;
  slideDown = false;
  @ContentChild('body') protected bodyTemplate: TemplateRef<unknown>;
  @ContentChild('title') protected titleTemplate: TemplateRef<unknown>;
  @ViewChild('backDropRef') protected backDropRef: ElementRef<unknown>;
  protected isOpen: boolean;
  private nativeElement: HTMLElement;
  private elementRef = inject(ElementRef);

  constructor() {
    this.nativeElement = this.elementRef.nativeElement;
    this.close();
    this.modalClose = new EventEmitter<void>();
    this.isOpen = false;
  }

  open(): void {
    if (this.appendToBody && this.nativeElement.parentElement !== document.body) {
      document.body.appendChild(this.nativeElement);
    }
    this.nativeElement.style.display = 'block';
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
  }
  close(emitEvent = true): void {
    if (!this.closable) {
      return;
    }
    this.nativeElement.style.display = 'none';
    this.isOpen = false;
    document.body.style.overflow = 'auto';
    if (emitEvent && this.modalClose) {
      this.modalClose.emit();
    }
  }

  closeFromBackDrop(e: MouseEvent): void {
    const targetElement = e.target as HTMLElement;
    const ref = this.backDropRef;
    if (ref) {
      const backDropElement = ref.nativeElement as HTMLElement;
      if (!backDropElement) {
        return;
      }

      if (targetElement !== backDropElement) {
        return;
      }
    }
    this.close();
  }

  onTouchStart(event: TouchEvent) {
    if (this.closable) {
      this.startY = event.touches[0].clientY;
      this.animateBack = false;
      this.slideDown = false;
    }
  }

  onTouchMove(event: TouchEvent) {
    if (this.closable) {
      const touchY = event.touches[0].clientY;
      const deltaY = touchY - this.startY;
      this.currentTranslateY = deltaY > 0 ? deltaY : 0;
    }
  }

  onTouchEnd(event: TouchEvent) {
    if (this.closable) {
      if (this.currentTranslateY > this.threshold) {
        this.slideDown = true;
      } else {
        this.animateBack = true;
        this.currentTranslateY = 0;
      }
    }
  }

  onTransitionEnd() {
    if (this.slideDown) {
      this.close();
    }
    this.resetModalState();
  }

  resetModalState() {
    this.currentTranslateY = 0;
    this.slideDown = false;
    this.animateBack = false;
  }

  ngOnDestroy(): void {
    this.closable = true;
    this.close(false);
  }
}
